import { AxiosInstance } from 'axios'
import { inject } from 'tsyringe'
import { httpToken } from '~/constants/dependency-injection/tokens'
import { containerScoped } from '~/decorators/dependency-container'
import RequestBuilder from '~/builders/http/RequestBuilder'
import { toCamelCase } from '~/utils/object'
import {
  BlacklistActionInfo,
  BlacklistInfo,
  BlacklistInformUsersInfo
} from '~/models/blacklist/types'
import { toSnakeCase } from '~/utils/snake-case'

@containerScoped()
export default class ClassifiedBlacklistService {
  constructor(
    @inject(httpToken) private http: AxiosInstance,
    @inject(RequestBuilder) private requestBuilder: RequestBuilder
  ) {}

  getClassifiedBlacklistInfo(classifiedId: number): Promise<BlacklistInfo> {
    return this.requestBuilder
      .request('get', `/api/admin/classifieds/${classifiedId}/blacklist/`)
      .send()
  }

  removeClassifiedFromBlacklist(
    classifiedId: number
  ): Promise<BlacklistActionInfo> {
    return this.requestBuilder
      .request('delete', `/api/admin/classifieds/${classifiedId}/blacklist/`)
      .map(body => toCamelCase(body))
      .send()
  }

  addClassifiedToBlacklist(data: {
    classifiedId: number
    reasonId: number
    notes: string
    blacklistCategories: number[]
    breakGroup: boolean
  }): Promise<BlacklistActionInfo> {
    return this.requestBuilder
      .request('post', `/api/admin/classifieds/${data.classifiedId}/blacklist/`)
      .data(toSnakeCase(data))
      .map(body => toCamelCase(body))
      .send()
  }

  updateBlacklist(data: {
    classifiedId: number
    reasonId: number
    notes: string
    blacklistCategories: number[]
    groupId: number
  }): Promise<BlacklistActionInfo> {
    return this.requestBuilder
      .request('put', `api/admin/blacklist/${data.groupId}/categories/edit/`)
      .data(toSnakeCase(data))
      .send()
  }

  public breakBlacklist(
    classifiedId: string | number
  ): Promise<BlacklistActionInfo> {
    return this.requestBuilder
      .request(
        'post',
        `/api/admin/classifieds/${classifiedId}/blacklist/break/`
      )
      .action()
      .send()
  }

  informUsers({
    classifiedId
  }: {
    classifiedId: number
  }): Promise<BlacklistInformUsersInfo> {
    return this.requestBuilder
      .request('post', `/api/admin/blacklist/${classifiedId}/inform/`)
      .send()
  }
}
